import axiosInstance from "../../lib/axiosInstance";
export const listDownloads = async () => {
  try {
    const response = await axiosInstance.get("/downloads");

    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.detail || "Failed to fetch downloaded files"
    );
  }
};


export const getDownloadUrl = async (key) => {
  try {
    const response = await axiosInstance.get("/download-url", {
      params: { key }
    });

    return response.data.url;
  } catch (error) {
    console.error("Full error:", error);

    const detail = error?.response?.data?.detail;

    throw new Error(
      typeof detail === "string"
        ? detail
        : JSON.stringify(detail) || "Failed to get download URL"
    );
  }
};